export const fullName = (firstName, middleName, lastName) => {
  return `${firstName} ${middleName} ${lastName}`
    ?.replace(/null|NULL/g, " ")
    ?.replace(/undefined|UNDEFINED/g, " ")
    ?.replace(/\s+/g, " ")
    ?.trim();
};
